import { render, staticRenderFns } from "./TrainingFaqs.vue?vue&type=template&id=514e4f19&scoped=true&"
import script from "./TrainingFaqs.vue?vue&type=script&lang=js&"
export * from "./TrainingFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e4f19",
  null
  
)

export default component.exports